import { useEffect, useState, } from "react";
import { Transition } from "history";
import { useModalContext } from "@context/use-modal-context";
import { navigateToUtil } from "@utils/navigation-util";
import { useLocation, useNavigate } from "react-router";
import { DiscardChangesModal } from "@containers/modals/discard-changes-modal/discard-changes-modal";
import { ModalTypes } from "@enums/modal-types";
import { usePrompt } from "@hooks/use-prompt";

type HookProps = {
    modalIdPrefix: string;
    modalType: ModalTypes;
    stateIsUnchanged: boolean;
};

export const useDiscardChangesModal = (props: HookProps) => {
    const {
        modalIdPrefix,
        modalType,
        stateIsUnchanged
    } = props;

    const navigate = useNavigate();
    const routerLocation = useLocation();
    const modalContext = useModalContext();

    const [tx, setTx] = useState<Transition>(null);
    const [disableNavigation, setDisableNavigation] = useState(true);

    useEffect(() => {
        const handleBeforeUnload = (event: BeforeUnloadEvent) => {
            event.stopImmediatePropagation();
        };

        window.addEventListener("beforeunload", handleBeforeUnload);

        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, []);

    useEffect(() => {
        if (!disableNavigation && tx) {
            navigateToUtil(tx.location.pathname, navigate, routerLocation.pathname);
        }
    }, [disableNavigation, tx]);

    const onClickContinue = (tx: Transition) => {
        setTx(tx);
        setDisableNavigation(false);
    };

    const displayDiscardChangesModal = (tx: Transition) => {
        const renderDiscardChangesModal = (onModalClose: () => void) => {
            return (
                <DiscardChangesModal
                    onModalClose={onModalClose}
                    onClickContinue={onClickContinue}
                    tx={tx}
                    idPrefix={modalIdPrefix}
                />
            );
        };

        modalContext.setModalState({
            modalType: modalType,
            renderFunction: renderDiscardChangesModal
        });
    };

    usePrompt(displayDiscardChangesModal, !stateIsUnchanged && disableNavigation);

    return <></>;
}    